import r from "./restArguments.js";
import t from "./isFunction.js";
import o from "./map.js";
import n from "./_deepGet.js";
import e from "./_toPath.js";
var i = r(function (r, i, m) {
  var f, p;
  return t(i) ? p = i : (f = (i = e(i)).slice(0, -1), i = i[i.length - 1]), o(r, function (r) {
    var t = p;
    if (!t) {
      if (f && f.length && (r = n(r, f)), null == r) return;
      t = r[i];
    }
    return null == t ? t : t.apply(r, m);
  });
});
export { i as default };